let domLoaded = false;
let igReady = false;

function handleExperiment() {
  if (domLoaded && igReady) {
    // Shop by Room ATF Test
    const shopByRoomATF = window.igData?.user.getTestGroup(
      "38ffbdf4-dcf8-42a4-a654-8321773c44ef"
    );

    if (window.location.pathname === "/" || window.location.pathname === "") {
      if (shopByRoomATF?.name === "Var A - Visual") {
        document.body.classList.add("c-shop-by-room-atf-varA");

        // Hide existing Shop by Room section on homepage
        const existingShopByRoom = document.querySelector('.image-carousel');
        if (existingShopByRoom) {
          existingShopByRoom.style.display = 'none';
        }
      } else if (shopByRoomATF?.name === "Var B - Text") {
        document.body.classList.add("c-shop-by-room-atf-varB");

        // Hide existing Shop by Room section on homepage
        const existingShopByRoom = document.querySelector('.image-carousel');
        if (existingShopByRoom) {
          existingShopByRoom.style.display = 'none';
        }
      } else {
        document.body.classList.add("c-shop-by-room-atf-control");
      }
    } else {
      document.body.classList.add("c-shop-by-room-atf-control");
    }

    // Mobile menu test
    const mobileMenuTest = window.igData?.user.getTestGroup(
      "ead5047b-cd7d-452d-a853-018262a8d097"
    );

    if (mobileMenuTest?.name === "Var A") {
      document.body.classList.add("c-mobile-menu-varA");
    }

    // Collection Card Slider Test
    const collectionCardSliderTest = window.igData?.user.getTestGroup(
      "2746de30-e3ae-43d6-8382-ba51fe726d6d"
    );

    if (window.location.pathname.includes("/collections/")) {
      if (collectionCardSliderTest?.name === "Var A") {
        document.body.classList.add("c-collection-card-slider-varA");
      } else {
        document.body.classList.add("c-collection-card-slider-control");
      }
    } else {
      document.body.classList.add("c-collection-card-slider-control");
    }

    // Price Comparison Modal Test
    const priceComparisonTest = window.igData?.user.getTestGroup(
      "7a39c6c7-2408-4f9e-9887-4d737369b194"
    );

    if (window.location.pathname.includes('/products/')) {
      if (priceComparisonTest?.name === "Var A") {
        document.body.classList.add("c-price-comparison-varA");
      } else {
        document.body.classList.add("c-price-comparison-control");
      }
    } else {
      document.body.classList.add("c-price-comparison-control");
    }

    // Popular Search Test
    const popularSearchTest = window.igData?.user.getTestGroup(
      "d954ac66-5c9a-40c4-830d-4fb996ca28f0"
    );

    if (popularSearchTest?.name === "Var A") {
      document.body.classList.add("c-popular-search-varA");
    } else {
      document.body.classList.add("c-popular-search-control");
    }

  }
}

function orderTracker() {
  const getBusinessDays = (date, days) => {
    let currentDate = new Date(date),
      added = 0;
    while (added < days) {
      currentDate.setDate(currentDate.getDate() + 1);
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) added++;
    }
    return new Date(currentDate);
  };

  const formatDate = (d) =>
    d.toLocaleDateString("en-US", { day: "numeric", month: "short" });
  const formatRange = (start, end) => {
    const s = formatDate(start),
      e = formatDate(end);
    return s === e ? s : `${s} - ${e}`;
  };

  const today = new Date();
  document.getElementById("c-order-date").textContent = formatDate(
    getBusinessDays(today, 0)
  );
  document.getElementById("c-packed-date").textContent = formatRange(
    getBusinessDays(today, 1),
    getBusinessDays(today, 2)
  );
  document.getElementById("c-delivery-date-var-c").textContent = formatRange(
    getBusinessDays(today, 3),
    getBusinessDays(today, 5)
  );
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;

  if (window.location.pathname === "/" || window.location.pathname === "") {
    document.body.classList.add("c-search-varC-test");
  } else if (window.location.pathname.includes('/products/') && window.innerWidth <= 768) {
    document.body.classList.add("c-search-varA-test");
  } else {
    document.body.classList.add("c-search-control-test");
  }

  handleExperiment();

  if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    document.documentElement.classList.add("safari");
  }

  document
    .querySelector(".c-header__search-new")
    ?.addEventListener("click", function (e) {
      e.preventDefault();
      const detailsEl = document
        .querySelector(".header__icon--search")
        ?.closest("details");
      if (detailsEl) {
        detailsEl.setAttribute("open", "");
        detailsEl.dispatchEvent(new Event("toggle", { bubbles: true }));
      }
    });

  // Price Comparison Modal - Handle icon click
  const priceComparisonIcon = document.querySelector(".c-price-comparison-text__icon");
  if (priceComparisonIcon) {
    priceComparisonIcon.addEventListener("click", function (e) {
      e.preventDefault();
      const modalId = this.getAttribute("data-modal");
      if (modalId) {
        const modal = document.querySelector(modalId);
        if (modal && typeof modal.show === "function") {
          modal.show(this);
        }
      }
    });
  }

  // Popular Search Test - Handle tag clicks
  const popularSearchTags = document.querySelectorAll(".c-popular-search-tag");
  popularSearchTags.forEach(tag => {
    tag.addEventListener("click", function (e) {
      e.preventDefault();
      const searchTerm = this.getAttribute("data-search-term");
      if (searchTerm) {
        // Encode the search term for URL
        const encodedTerm = encodeURIComponent(searchTerm);
        // Redirect to search results page with query parameter
        window.location.href = `/pages/search-results?q=${encodedTerm}`;
      }
    });
  });
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiment();

  // Price Comparison Modal - Handle icon click (after Intelligems is ready)
  const priceComparisonIcon = document.querySelector(".c-price-comparison-text__icon");
  if (priceComparisonIcon) {
    priceComparisonIcon.addEventListener("click", function (e) {
      e.preventDefault();
      const modalId = this.getAttribute("data-modal");
      if (modalId) {
        const modal = document.querySelector(modalId);
        if (modal && typeof modal.show === "function") {
          modal.show(this);
        }
      }
    });
  }

  // Popular Search Test - Handle tag clicks (after Intelligems is ready)
  const popularSearchTags = document.querySelectorAll(".c-popular-search-tag");
  popularSearchTags.forEach(tag => {
    tag.addEventListener("click", function (e) {
      e.preventDefault();
      const searchTerm = this.getAttribute("data-search-term");
      if (searchTerm) {
        // Encode the search term for URL
        const encodedTerm = encodeURIComponent(searchTerm);
        // Redirect to search results page with query parameter
        window.location.href = `/pages/search-results?q=${encodedTerm}`;
      }
    });
  });
});